import { useEffect, useState } from "react";
import client from "../api/client";

const styles = {
  page: { fontSize: 11 },
  card: {
    border: 0,
    borderRadius: 14,
    overflow: "hidden",
    boxShadow: "0 2px 10px rgba(0,0,0,.08)",
    background: "#fff",
  },
  header: {
    background: "linear-gradient(90deg, #22052D, #CCB3D1)",
    color: "#fff",
    padding: "8px 12px",
  },
  title: {
    fontSize: 13,
    fontWeight: 700,
    margin: 0,
  },
  sub: {
    fontSize: 10,
    opacity: 0.85,
  },
  body: {
    padding: 10,
  },
  label: {
    fontSize: 10,
    fontWeight: 700,
    marginBottom: 3,
    color: "#495057",
  },
  input: {
    height: 30,
    fontSize: 11,
    borderRadius: 7,
  },
  btn: {
    height: 30,
    fontSize: 11,
    borderRadius: 7,
    fontWeight: 600,
  },
  tableWrap: {
    maxHeight: 280,
    overflowY: "auto",
    overflowX: "auto",
    border: "1px solid #e9ecef",
    borderRadius: 10,
  },
  table: {
    fontSize: 11,
    minWidth: 850,
    marginBottom: 0,
  },
  th: {
    fontSize: 10,
    padding: "7px 8px",
    color: "#fff",
    whiteSpace: "nowrap",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  td: {
    fontSize: 11,
    padding: "6px 8px",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  },
};

export default function StockAdjustmentPage() {
  const [items, setItems] = useState([]);
  const [rows, setRows] = useState([]);

  const [form, setForm] = useState({
    companyId: Number(localStorage.getItem("companyId") || 1),
    voucherNo: "SA-001",
    voucherDate: new Date().toISOString().slice(0, 10),
    adjustmentType: "IN",
    notes: "",
    details: [{ itemId: "", qty: 1, rate: 0, notes: "" }],
  });

  const load = async () => {
    const itemRes = await client.get("/inventory/items");
    setItems(itemRes.data || []);

    const stockRes = await client.get(
      `/stockadjustments?companyId=${form.companyId}`,
    );

    setRows(stockRes.data || []);
  };

  useEffect(() => {
    load();
  }, []);

  const setLine = (i, k, v) =>
    setForm((p) => ({
      ...p,
      details: p.details.map((x, idx) => (idx === i ? { ...x, [k]: v } : x)),
    }));

  const add = () =>
    setForm((p) => ({
      ...p,
      details: [...p.details, { itemId: "", qty: 1, rate: 0, notes: "" }],
    }));

  const remove = (index) => {
    if (form.details.length === 1) return alert("At least one row required");

    setForm((p) => ({
      ...p,
      details: p.details.filter((_, i) => i !== index),
    }));
  };

  const save = async () => {
    try {
      debugger;
      await client.post("/stockadjustments", {
        ...form,
        details: form.details.map((x) => ({
          ...x,
          itemId: Number(x.itemId),
          qty: Number(x.qty),
          rate: Number(x.rate),
        })),
      });

      alert("Stock adjustment saved");

      setForm({
        companyId: Number(localStorage.getItem("companyId") || 1),
        voucherNo: "SA-001",
        voucherDate: new Date().toISOString().slice(0, 10),
        adjustmentType: "IN",
        notes: "",
        details: [{ itemId: "", qty: 1, rate: 0, notes: "" }],
      });

      load();
    } catch {
      alert("Failed to save stock adjustment");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h6 style={styles.title}>
            <i className="bi bi-box-arrow-in-down me-2"></i>
            Stock Adjustment
          </h6>

          <div style={styles.sub}>
            Stock increase / decrease with inventory adjustment tracking
          </div>
        </div>

        <div style={styles.body}>
          <div className="row g-2 mb-2">
            <Field label="Company Id" className="col-md-2">
              <input
                className="form-control form-control-sm"
                style={styles.input}
                value={form.companyId}
                onChange={(e) =>
                  setForm({ ...form, companyId: e.target.value })
                }
              />
            </Field>

            <Field label="Voucher No" className="col-md-2">
              <input
                className="form-control form-control-sm"
                style={styles.input}
                value={form.voucherNo}
                onChange={(e) =>
                  setForm({ ...form, voucherNo: e.target.value })
                }
              />
            </Field>

            <Field label="Date" className="col-md-2">
              <input
                type="date"
                className="form-control form-control-sm"
                style={styles.input}
                value={form.voucherDate}
                onChange={(e) =>
                  setForm({ ...form, voucherDate: e.target.value })
                }
              />
            </Field>

            <Field label="Type" className="col-md-2">
              <select
                className="form-select form-select-sm"
                style={styles.input}
                value={form.adjustmentType}
                onChange={(e) =>
                  setForm({ ...form, adjustmentType: e.target.value })
                }
              >
                <option value="IN">IN</option>
                <option value="OUT">OUT</option>
              </select>
            </Field>

            <Field label="Notes" className="col-md-4">
              <input
                className="form-control form-control-sm"
                style={styles.input}
                value={form.notes}
                onChange={(e) => setForm({ ...form, notes: e.target.value })}
                placeholder="Example: Enter purpose, reference bill/invoice no., payment terms or adjustment reason"
              />
            </Field>
          </div>

          <div style={styles.tableWrap} className="mb-2">
            <table
              className="table table-bordered table-hover align-middle"
              style={styles.table}
            >
              <thead>
                <tr>
                  <th style={{ ...styles.th, minWidth: 250 }}>Item</th>
                  <th style={{ ...styles.th, minWidth: 100 }}>Qty</th>
                  <th style={{ ...styles.th, minWidth: 100 }}>Rate</th>
                  <th style={{ ...styles.th, minWidth: 220 }}>Notes</th>
                  <th style={{ ...styles.th, minWidth: 70 }}>Action</th>
                </tr>
              </thead>

              <tbody>
                {form.details.map((l, i) => (
                  <tr key={i}>
                    <td style={styles.td}>
                      <select
                        className="form-select form-select-sm"
                        style={styles.input}
                        value={l.itemId}
                        onChange={(e) => setLine(i, "itemId", e.target.value)}
                      >
                        <option value="">Select Item</option>

                        {items.map((it) => (
                          <option key={it.id || it.Id} value={it.id || it.Id}>
                            {(it.itemCode || it.ItemCode) +
                              " - " +
                              (it.itemName || it.ItemName)}
                          </option>
                        ))}
                      </select>
                    </td>

                    <td style={styles.td}>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        style={styles.input}
                        value={l.qty}
                        onChange={(e) => setLine(i, "qty", e.target.value)}
                      />
                    </td>

                    <td style={styles.td}>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        style={styles.input}
                        value={l.rate}
                        onChange={(e) => setLine(i, "rate", e.target.value)}
                      />
                    </td>

                    <td style={styles.td}>
                      <input
                        className="form-control form-control-sm"
                        style={styles.input}
                        value={l.notes}
                        onChange={(e) => setLine(i, "notes", e.target.value)}
                      />
                    </td>

                    <td style={styles.td}>
                      <button
                        className="btn btn-danger btn-sm"
                        style={{
                          ...styles.btn,
                          height: 25,
                          padding: "2px 8px",
                        }}
                        onClick={() => remove(i)}
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="d-flex gap-2 mb-3">
            <button
              className="btn btn-outline-secondary btn-sm"
              style={styles.btn}
              onClick={add}
            >
              <i className="bi bi-plus-circle me-1"></i>
              Add Line
            </button>

            <button
              className={`btn btn-sm ${
                form.adjustmentType === "IN" ? "btn-success" : "btn-danger"
              }`}
              style={styles.btn}
              onClick={save}
            >
              <i className="bi bi-check2-circle me-1"></i>
              Save Adjustment
            </button>
          </div>

          <div
            style={{
              fontSize: 10,
              color: "#6c757d",
              marginBottom: 6,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span>
              Recent Adjustments: <strong>{rows.length}</strong>
            </span>
            <span>Inventory movement history</span>
          </div>

          <div style={styles.tableWrap}>
            <table
              className="table table-bordered table-hover align-middle"
              style={{ ...styles.table, minWidth: 650 }}
            >
              <thead>
                <tr>
                  <th style={styles.th}>Voucher No</th>
                  <th style={styles.th}>Date</th>
                  <th style={styles.th}>Type</th>
                  <th style={styles.th}>Notes</th>
                </tr>
              </thead>

              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td
                      colSpan="4"
                      className="text-center text-muted"
                      style={{ ...styles.td, padding: 18 }}
                    >
                      No adjustments found
                    </td>
                  </tr>
                ) : (
                  rows.map((r, i) => (
                    <tr key={i}>
                      <td style={{ ...styles.td, fontWeight: 700 }}>
                        {r.voucherNo || r.VoucherNo}
                      </td>

                      <td style={styles.td}>
                        {String(r.voucherDate || r.VoucherDate).slice(0, 10)}
                      </td>

                      <td style={styles.td}>
                        <span
                          className={`badge ${
                            (r.adjustmentType || r.AdjustmentType) === "IN"
                              ? "text-bg-success"
                              : "text-bg-danger"
                          }`}
                          style={{ fontSize: 10 }}
                        >
                          {r.adjustmentType || r.AdjustmentType}
                        </span>
                      </td>

                      <td style={styles.td}>{r.notes || r.Notes}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, className, children }) {
  return (
    <div className={className}>
      <label style={styles.label}>{label}</label>
      {children}
    </div>
  );
}
